import {
  CKFinderApplicationInterface,
  CKFinderEventInfoInterface,
  CKFileKindType,
  CKConfigType,
} from '@/modules/types/ckFinder';
import cn from 'classnames';
import React, { useState } from 'react';
import { UseFormRegister } from 'react-hook-form';
import './index.scss';
import { getCKFileName } from '@/lib/util';

type CKFileUploadProps = {
  register: UseFormRegister<any>;
  registerName: string;
  defaultFileName: string;
  fileType: CKFileKindType;
  connectorDetails: CKConfigType;
  handlerFunction: {
    onFileChoose: (fileName: string) => void;
    [key: string]: (args: any) => any;
  };
};

export const browseAssets = (
  connectorDetails: CKConfigType,
  onFileSelectHandler: (filename: string) => void,
) => {
  const { connectorInfo, connectorPath } = connectorDetails;

  CKFinder.popup({
    connectorPath,
    connectorInfo,
    chooseFiles: true,
    width: 800,
    height: 600,
    onInit(finder: CKFinderApplicationInterface) {
      finder.on('files:choose', (event: CKFinderEventInfoInterface) => {
        const { files } = event.data;
        let currentFileName = '';
        files.forEach((file) => {
          currentFileName = file.get('name');
        });

        onFileSelectHandler(currentFileName);
      });
    },
  });
};

const CKFileUpload = ({
  handlerFunction,
  connectorDetails,
  register,
  registerName,
  defaultFileName,
  fileType,
}: CKFileUploadProps): React.ReactElement => {
  const { onFileChoose } = handlerFunction;
  const [fileName, setFileName] = useState(
    getCKFileName(defaultFileName, `/${fileType}/`),
  );

  const onFileSelectHandler = (currentFileName: string) => {
    setFileName(currentFileName);
    onFileChoose(currentFileName);
  };
  const onClickHandler = () => {
    browseAssets(connectorDetails, onFileSelectHandler);
  };

  return (
    <div
      id="CKFileUpload"
      className={cn('ela-ck-file-upload-wrapper', {
        'has-file': fileName,
      })}
    >
      <div
        className={cn('ela-ck-fileupload-files', {
          'ela-ck-fileupload-files-exist': fileName,
        })}
        title={fileName}
      >
        <input
          className="ck-file-upload-input"
          type="text"
          {...register(registerName, {})}
        />
      </div>
      <div className="ela-ck-fileupload-input">
        <button
          className="sc-bczRLJ iDNYrR ela-ck-btn ela-ck-btn--primary ela-ck-btn--is-uppercase ela-ck-btn--xl"
          type="button"
          onClick={onClickHandler}
          onKeyDown={onClickHandler}
        >
          <span className="ela-ck-btn__label">Upload</span>
        </button>
      </div>
    </div>
  );
};

export default CKFileUpload;
